import { useMemo } from 'react'
import { useNavigate } from 'react-router'

import { useUserSubscription } from '../api/get-user-subscription'

import { SidebarMenuButton, SidebarMenuItem, useSidebar } from '@/components/ui/sidebar'
import { paths } from '@/config/path'
import { daysUntil, niceDateShort } from '@/utils/time'
import {  buttonVariants } from '@/components/ui/button'
import { CalendarClockIcon } from 'lucide-react'

export const TrialSidebarItem = () => {
  const { state } = useSidebar()
  const { data: subscription, isPending, isError } = useUserSubscription()
  const navigate = useNavigate()

  const trialInfo = useMemo(() => {
    if (!subscription || !subscription.trial_end) return null
    const days = daysUntil(subscription.trial_end)
    return {
      isTrialing: subscription.status === 'trial' && days > -1,
      daysLeft: Math.max(days, 0),
      trialEndLabel: niceDateShort(subscription.trial_end),
    }
  }, [subscription])

  if (state === 'collapsed' || isPending || isError || !trialInfo || !trialInfo.isTrialing) {
    return null
  }

  return (
    <SidebarMenuItem className='border rounded-sm' onClick={() => navigate(paths.app.settings.getHref('billing'))}>
      <SidebarMenuButton className='flex items-center justify-between'>
        <CalendarClockIcon className='size-3.5'/>
        <span>{trialInfo.daysLeft} restant{trialInfo.daysLeft > 1 ? 's' : ''}</span>
        <span className={buttonVariants({variant: 'link'})}>Gérer</span>
      </SidebarMenuButton>
    </SidebarMenuItem>
  )
}

export default TrialSidebarItem